import React, { useState } from "react";
import "../styles/QuantityInput.css";

const QuantityInput = ({ onConfirm, onClose, currentQuantity, item }) => {
  const [quantity, setQuantity] = useState(currentQuantity?.toString() || "1");

  const handleNumberClick = (value) => {
    setQuantity((prev) => {
      if (value === "." && prev.includes(".")) return prev;
      if (value === "." && prev === "") return "0.";
      if (prev === "0" && value !== "." && value !== "0") return value;
      return prev + value;
    });
  };

  const handleClear = () => setQuantity("");
  const handleBackspace = () => setQuantity((prev) => prev.slice(0, -1));

  const handleConfirm = () => {
    const newQuantity = parseFloat(quantity);
    if (newQuantity > 0) {
      // Cuando se confirma, enviamos la nueva cantidad
      // El App.js se encargará de actualizar el producto y sus modificadores
      onConfirm(newQuantity);
      onClose();
    }
  };

  return (
    <div className="quantity-input-modal">
      <div className="quantity-input">
        <h3>INGRESAR CANTIDAD</h3>
        
        {/* Mostrar información del producto y sus modificadores */}
        {item && (
          <div className="item-info">
            <p><strong>{item.name}</strong></p>
            {item.modifiers && item.modifiers.length > 0 && (
              <div className="modifiers-info">
                <small>Modificadores:</small>
                <ul>
                  {item.modifiers.map((mod, idx) => (
                    <li key={idx}>
                      {mod.name} (x{mod.quantity || 1})
                    </li>
                  ))}
                </ul>
                <small className="info-note">
                  * La cantidad se aplicará tanto al producto como a sus modificadores
                </small>
              </div>
            )}
          </div>
        )}
        
        <input 
          type="text" 
          value={quantity} 
          readOnly 
          placeholder="0"
        />
        
        <div className="numeric-keyboard">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
            <button key={num} onClick={() => handleNumberClick(num.toString())}>
              {num}
            </button>
          ))}
          <button onClick={() => handleNumberClick(".")}>.</button>
          <button onClick={() => handleNumberClick("0")}>0</button>
          <button onClick={handleBackspace}>⌫</button>
          <button onClick={handleClear}>C</button>
          <button onClick={handleConfirm}>ACEPTAR</button>
        </div>
      </div>
    </div>
  );
};

export default QuantityInput;